import {ErrorHandler, inject, Injectable, Injector, NgZone} from '@angular/core';
import {GlobalErrorConfig} from "../../../_config/global-error";

/**
 * Global error handling service, this service allows you to configure from "src\_config\global-error.ts"
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler{
  private injector: Injector = inject(Injector);
  private ngZone = inject(NgZone);


  handleError(error: any): void {

    if (!GlobalErrorConfig.enable) {
      throw error;
    }

    console.info('Start Global Handler Error')
    console.error('ErrorHandler ->', error)
    console.info('End Global Handler Error')

    this.ngZone.run(() => {
      GlobalErrorConfig.handleError(error, this.injector);
    })
  }


}
